import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, PasswordField, FormError, SubmitButton, AuthLink } from "@/components/auth/AuthShell";

export default function ResetPassword({ setup = false }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.get(`/auth/token-info/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errorMessage(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(setup ? "Password saved. Please sign in." : "Password updated. Please sign in.");
      navigate("/login", { state: { email: info?.email } });
    } catch (err) { setError(errorMessage(err)); } finally { setLoading(false); }
  };

  const isSetup = setup || info?.is_setup;
  return (
    <AuthShell
      title={isSetup ? `Welcome${info?.name ? `, ${info.name.split(" ")[0]}` : ""}` : "Choose a new password"}
      subtitle={isSetup ? `Set a password for ${info?.email || "your account"} to finish setting up.` : null}
      footer={<AuthLink to="/login" testId="reset-back-link">Back to sign in</AuthLink>}>
      {!token ? (
        <FormError message="This link is missing its token. Please request a new one." />
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <PasswordField id="password" label="New password (8+ characters)" value={password} onChange={setPassword} autoComplete="new-password" testId="reset-password-input" />
          <PasswordField id="confirm" label="Confirm new password" value={confirm} onChange={setConfirm} autoComplete="new-password" testId="reset-confirm-input" />
          <FormError message={error} />
          <SubmitButton loading={loading} testId="reset-submit-button">{isSetup ? "Save password and continue" : "Update password"}</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
